module.exports = __webpack_public_path__ + "img/button-p1=hover.bf2c2b94.png";